import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../../services/content/business.lib.js";
import { POPUP_VISIT_EXTERNAL_LINK_DEVELOPMENT_KEY } from "../../AdBuilder/constants.js";
import { AD_BUTLER_NO_ADS_STATUS } from "../constants.js";
import { fetchAdButlerData } from "../utils.js";
import { AdButlerClient } from "./AdButlerClient.js";
const AdButler = async ({
  entry,
  adButlerConfigData,
  titleProps,
  isSearchPage = false,
  keyword,
  locale,
  maxSlidesBySize
}) => {
  const { third_party_curation } = entry || {};
  const { adbutler_extension } = third_party_curation;
  const { siteId, kw } = adButlerConfigData;
  let adData = null;
  if (!adbutler_extension) {
    return null;
  }
  if (!siteId) {
    console.error(
      "Missing siteId from the ad butler config in content stack"
    );
    return null;
  }
  if (!isSearchPage) {
    try {
      const adButlerApiResponse = await fetchAdButlerData(
        siteId,
        adbutler_extension,
        null,
        keyword || kw
      );
      const { placements, status } = adButlerApiResponse;
      if (status !== AD_BUTLER_NO_ADS_STATUS) {
        adData = placements;
      }
    } catch {
      console.error(
        `Error occured in fetching ad butler ads for siteId: ${siteId} and zoneId: ${adbutler_extension}`
      );
    }
  }
  let heroCarouselData = null;
  try {
    heroCarouselData = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      "homepage_hero_carousel",
      locale
    );
  } catch {
    heroCarouselData = { key_value: [] };
  }
  let externalLinkModule;
  try {
    externalLinkModule = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      POPUP_VISIT_EXTERNAL_LINK_DEVELOPMENT_KEY,
      locale
    );
  } catch (err) {
    console.error(
      "Failed loading externalLinkModule in ad butler component",
      err
    );
  }
  const moduleSettings = heroCarouselData;
  return /* @__PURE__ */ jsx(
    AdButlerClient,
    {
      adButlerConfig: adButlerConfigData,
      adData,
      entry,
      externalLinkModule,
      isSearchPage,
      keyword,
      locale,
      moduleSettings,
      titleProps,
      maxSlidesBySize
    }
  );
};
export {
  AdButler
};
